/* HAND-AUTHORED (the artifact pipeline was unavailable for this stage) — stage "x-agents".
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. */

import type { NodeDef } from '../../types';

export const N_X_AGENTS: NodeDef = {
  "id": "x-agents",
  "tagKey": "path:x-agents.tag",
  "x": 656,
  "y": 440,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-agents.title",
  "subKey": "path:x-agents.sub",
  "blocks": [
    {
      "id": "x-agents.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-agents.b1.title",
      "bodyKey": "path:x-agents.b1.body",
      "flowKey": "path:x-agents.b1.flow",
      "read": [
        "react"
      ]
    },
    {
      "id": "x-agents.b2",
      "kind": "tree",
      "xp": 25,
      "titleKey": "path:x-agents.b2.title",
      "tree": {
        "qKey": "path:x-agents.b2.tree.q",
        "branches": [
          {
            "tone": "warn",
            "aKey": "path:x-agents.b2.tree.b.0.a",
            "verdictKey": "path:x-agents.b2.tree.b.0.verdict"
          },
          {
            "tone": "pass",
            "aKey": "path:x-agents.b2.tree.b.1.a",
            "verdictKey": "path:x-agents.b2.tree.b.1.verdict"
          },
          {
            "tone": "stop",
            "aKey": "path:x-agents.b2.tree.b.2.a",
            "verdictKey": "path:x-agents.b2.tree.b.2.verdict"
          },
          {
            "tone": "warn",
            "aKey": "path:x-agents.b2.tree.b.3.a",
            "verdictKey": "path:x-agents.b2.tree.b.3.verdict"
          }
        ]
      }
    },
    {
      "id": "x-agents.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-agents.b3.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:x-agents.b3.ex.options.0.t",
            "ok": true,
            "fbKey": "path:x-agents.b3.ex.options.0.fb"
          },
          {
            "tKey": "path:x-agents.b3.ex.options.1.t",
            "ok": false,
            "fbKey": "path:x-agents.b3.ex.options.1.fb"
          },
          {
            "tKey": "path:x-agents.b3.ex.options.2.t",
            "ok": false,
            "fbKey": "path:x-agents.b3.ex.options.2.fb"
          },
          {
            "tKey": "path:x-agents.b3.ex.options.3.t",
            "ok": false,
            "fbKey": "path:x-agents.b3.ex.options.3.fb"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "tooling"
};